import { render, staticRenderFns } from "./RevenuePerAirport.vue?vue&type=template&id=7737c506&scoped=true&"
import script from "./RevenuePerAirport.vue?vue&type=script&lang=js&"
export * from "./RevenuePerAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7737c506",
  null
  
)

export default component.exports